import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';


export const ProductRegistrationService = () => {
    const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'ProductRegistrations', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="ProductRegistrations" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />
             <section class="service-details section-space">
                   <div class="container">
                       <div class="row flex-xl-row flex-column-reverse">
                           <div class="col-xl-4">
                               <div class="sidebar sidebar-rr-sticky">
                                   <div class="sidebar__widget-service mb-30">
                                   <Link to="/service">Medical Device Manufacturers <i class="fa-solid fa-plus"></i> </Link>
                                   <Link to="/pharmaceutical-details">Pharmaceutical & Biotech industry<i class="fa-solid fa-plus"></i> </Link>
                                   <Link to="/healthcare-details">Healthcare Providers <i class="fa-solid fa-plus"></i> </Link>
       
                                   </div>
       
                                   <div class="sidebar__widget-contact__service text-center">
                                       <h4 class="mb-25 title-animation text-capitalize">Are You ready to contact with us</h4>
                                       <p class="mb-20"><a href="tel:+86 19811976744"><i class="fa-solid fa-phone"></i>(+86) 19811976744</a></p>
       
                                       <Link to="/contact-us#" class="rr-btn">
                                           <span class="btn-wrap">
                                               <span class="text-one">Contact Us <i class="fa-solid fa-plus"></i></span>
                                               <span class="text-two">Contact Us <i class="fa-solid fa-plus"></i></span>
                                           </span>
                                       </Link>
                       </div>
                               </div>
                           </div>
                           <div class="col-xl-8">
                               <div class="service-details__content">
                               <div className="content-container">
                               <div class="service-details__content-media mb-20">
            <img src="./assets/imgs/service-details/service-details-1.jpg" class="img-fluid" alt="Technical Documentation" />
          </div>      
  <h3 className="section-title">
    <i className="fa-solid fa-clipboard-check text-primary"></i> Product Registrations
  </h3>
  <p className="document-description">
    Each medical device needs to be registered in a regulatory area/country before being able to start selling the device there. Each area has its own requirements and procedures.
  </p>

  <h4 className="document-title">
    <i className="fa-solid fa-certificate text-secondary"></i> CE Registration (EU)
  </h4>
  <p className="document-description">
    Medical device manufacturers in the EU must demonstrate compliance with the MDR (Medical Device Regulation) by meeting the General Safety and Performance Requirements (GSPRs). Conformity assessment procedures vary based on the risk class of the device.
  </p>

  <h5 className="sub-title">
    <i className="fa-solid fa-layer-group text-info"></i> Risk Classes and Conformity Assessment Procedures
  </h5>
  <ul className="custom-list">
    <li><strong>Class I Devices:</strong> Manufacturers can self-certify these devices without a Notified Body.</li>
    <li><strong>Class Im, Ir, Is, IIa, IIb, III Devices:</strong> These higher-risk classes require the involvement of a Notified Body.</li>
  </ul>

  <h5 className="sub-title">
    <i className="fa-solid fa-tasks text-warning"></i> Steps for Compliance
  </h5>

  <div className="steps-section">
    <h6 className="steps-title"><i className="fa-solid fa-shield-alt text-success"></i> For Devices Requiring a Notified Body:</h6>
    <ul className="custom-list">
      <li><strong>Conformity Assessment:</strong> Select and undergo the applicable assessment procedure with a Notified Body.</li>
      <li><strong>Certificate of Conformity:</strong> Obtain the certificate from the Notified Body.</li>
      <li><strong>Declaration of Conformity:</strong> Prepare and sign the declaration.</li>
      <li><strong>CE Marking:</strong> Affix the CE mark to the device.</li>
      <li><strong>Additional Requirements:</strong> Fulfill all conformity assessment requirements, including technical documentation and PMS plans.</li>
    </ul>

    <h6 className="steps-title"><i className="fa-solid fa-file-signature text-primary"></i> For Devices Not Requiring a Notified Body:</h6>
    <ul className="custom-list">
      <li><strong>Declaration of Conformity:</strong> Prepare and sign the declaration.</li>
      <li><strong>CE Marking:</strong> Affix the CE mark to the device.</li>
      <li><strong>Additional Requirements:</strong> Complete all documentation and risk assessment procedures.</li>
    </ul>
  </div>

  <h3 className="section-title">
    <i className="fa-solid fa-briefcase-medical text-primary"></i> SQUARE MEDTECH Expertise in Product Registration
  </h3>
  <p className="document-description">
    Leveraging SQUARE MEDTECH’s comprehensive solutions and expertise ensures your technical documentation is always up-to-date, compliant, and ready for regulatory submissions—supporting your product’s market success and patient safety.
  </p>

  <h5 className="sub-title">
    <i className="fa-solid fa-handshake text-success"></i> How SQUARE MEDTECH Supports Product Registration
  </h5>
  <ul className="custom-list">
    <li><i className="fa-solid fa-shield-alt text-primary"></i> Regulatory Compliance Expertise</li>
    <li><i className="fa-solid fa-chart-line text-secondary"></i> Conducting GAP Analysis of Existing Technical Documentation</li>
    <li><i className="fa-solid fa-clipboard-list text-info"></i> Planning Documentation for New Products/Projects</li>
    <li><i className="fa-solid fa-file-pen text-warning"></i> Documentation Preparation & Updates</li>
    <li><i className="fa-solid fa-cogs text-primary"></i> Quality Management System (QMS) Integration</li>
    <li><i className="fa-solid fa-user-graduate text-success"></i> Training & Support</li>
    <li><i className="fa-solid fa-laptop-code text-secondary"></i> Cybersecurity & Software Documentation</li>
    <li><i className="fa-solid fa-chart-pie text-danger"></i> Post-Market Surveillance (PMS) & Vigilance Reporting</li>
    <li><i className="fa-solid fa-paper-plane text-info"></i> Submission & Liaison with Regulatory Bodies</li>
  </ul>
</div>

                               </div>
                           </div>
                       </div>
                   </div>
               </section>
       
    </main>


    <section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Service for Product Registration:</h4>
                      <ul class="color-white mb-0">
                        <li>Post Market Activities</li>
                        <li>Technical Documentation</li>
                        <li>Quality Management System</li>
                      </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Service for Product Registration:</h4>
                    <ul class="color-white mb-0">
                      <li>QA / RA Service</li>
                      <li>Product Registrations</li>
                      <li>Digital Health Services</li>
                    </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    <FooterWhite/>

    </>
  )
}
